import {
  Directive,
  HostListener,
  inject,
  input,
  InputSignal,
  OnDestroy,
} from '@angular/core';
import { GeoserverCRS, MapService } from '@lassi/webapp-shared';
import { GeoJSON } from 'leaflet';

@Directive({ selector: '[libHighlightOnMap]', standalone: true })
export class HighlightOnMapDirective implements OnDestroy {
  geometry: InputSignal<GeoJSON.Geometry> = input.required<GeoJSON.Geometry>({
    alias: 'libHighlightOnMap',
  });

  crs = input<GeoserverCRS>();

  private readonly mapService = inject(MapService);

  private highlight: GeoJSON | undefined;

  @HostListener('mouseenter')
  handleMouseEnter() {
    this.highlight = this.mapService.highlight(this.geometry(), this.crs());
  }

  ngOnDestroy() {
    this.handleMouseLeave();
  }

  @HostListener('mouseleave')
  handleMouseLeave() {
    this.highlight?.remove();
  }
}
